export enum WorkLoadsEnum {
  PartTime = 'PART_TIME',
  FullTime = 'FULL_TIME',
}

export enum WorkFormatsEnum {
  Office = 'OFFICE',
  Mixed = 'MIXED',
  Remote = 'REMOTE',
}

export enum EmploymentFormsEnum {
  Employee = 'EMPLOYEE',
  Contractor = 'CONTRACTOR',
  Entrepreneur = 'ENTREPRENEUR',
  Internship = 'INTERNSHIP',
  Courses = 'COURSES',
}

export enum GenderEnum {
  Male = 'MALE',
  Female = 'FEMALE',
}

export enum LanguageLevelEnum {
  AOne = 'A_ONE',
  AOneMinus = 'A_ONE_MINUS',
  AOnePlus = 'A_ONE_PLUS',
  ATwo = 'A_TWO',
  ATwoMinus = 'A_TWO_MINUS',
  ATwoPlus = 'A_TWO_PLUS',
  BOne = 'B_ONE',
  BOneMinus = 'B_ONE_MINUS',
  BOnePlus = 'B_ONE_PLUS',
  BTwo = 'B_TWO',
  BTwoMinus = 'B_TWO_MINUS',
  BTwoPlus = 'B_TWO_PLUS',
  COne = 'C_ONE',
  COneMinus = 'C_ONE_MINUS',
  COnePlus = 'C_ONE_PLUS',
  CTwo = 'C_TWO',
  CTwoMinus = 'C_TWO_MINUS',
  CTwoPlus = 'C_TWO_PLUS',
}

export const LanguageLevelValues = {
  [LanguageLevelEnum.AOne]: 'A1',
  [LanguageLevelEnum.AOneMinus]: 'A1-',
  [LanguageLevelEnum.AOnePlus]: 'A1+',
  [LanguageLevelEnum.ATwo]: 'A2',
  [LanguageLevelEnum.ATwoMinus]: 'A2-',
  [LanguageLevelEnum.ATwoPlus]: 'A2+',
  [LanguageLevelEnum.BOne]: 'B1',
  [LanguageLevelEnum.BOneMinus]: 'B1-',
  [LanguageLevelEnum.BOnePlus]: 'B1+',
  [LanguageLevelEnum.BTwo]: 'B2',
  [LanguageLevelEnum.BTwoMinus]: 'B2-',
  [LanguageLevelEnum.BTwoPlus]: 'B2+',
  [LanguageLevelEnum.COne]: 'C1',
  [LanguageLevelEnum.COneMinus]: 'C1-',
  [LanguageLevelEnum.COnePlus]: 'C1+',
  [LanguageLevelEnum.CTwo]: 'C2',
  [LanguageLevelEnum.CTwoMinus]: 'C2-',
  [LanguageLevelEnum.CTwoPlus]: 'C2+',
};

export enum GradeEnum {
  Trainee = 'TRAINEE',
  Intern = 'INTERN',
  JuniorMinus = 'JUNIOR_MINUS',
  Junior = 'JUNIOR',
  JuniorPlus = 'JUNIOR_PLUS',
  MiddleMinus = 'MIDDLE_MINUS',
  Middle = 'MIDDLE',
  MiddlePlus = 'MIDDLE_PLUS',
  SeniorMinus = 'SENIOR_MINUS',
  Senior = 'SENIOR',
  SeniorPlus = 'SENIOR_PLUS',
  Lead = 'LEAD',
  HEAD = 'HEAD',
  ARCHITECT = 'ARCHITECT',
}

export const GradeValues = {
  [GradeEnum.Trainee]: 'Trainee',
  [GradeEnum.Intern]: 'Intern',
  [GradeEnum.JuniorMinus]: 'Junior-',
  [GradeEnum.Junior]: 'Junior',
  [GradeEnum.JuniorPlus]: 'Junior+',
  [GradeEnum.MiddleMinus]: 'Middle-',
  [GradeEnum.Middle]: 'Middle',
  [GradeEnum.MiddlePlus]: 'Middle+',
  [GradeEnum.SeniorMinus]: 'Senior-',
  [GradeEnum.Senior]: 'Senior',
  [GradeEnum.SeniorPlus]: 'Senior+',
  [GradeEnum.Lead]: 'Lead',
  [GradeEnum.HEAD]: 'Head',
  [GradeEnum.ARCHITECT]: 'Architect',
};

export enum CurrencyEnum {
  'PLN' = 'PLN',
  'EUR' = 'EUR',
  'USD' = 'USD',
  'BYN' = 'BYN',
  'RUB' = 'RUB',
}

export const defaultCurrency = CurrencyEnum.USD;

export enum IntervalFiltersType {
  OverallExperience = 'OVERALL_EXPERIENCE',
  Salary = 'SALARY',
  BirthDate = 'BIRTH_DATE',
  ItExperience = 'IT_EXPERIENCE',
  Age = 'AGE',
}

export enum PurposeEnum {
  Employment = 'EMPLOYMENT',
  Trainee = 'TRAINEE',
  Courses = 'COURSES',
}

export enum LanguageEnum {
  Dutch = 'DUTCH',
  Irish = 'IRISH',
  Hindi = 'HINDI',
  Greek = 'GREEK',
  Czech = 'CZECH',
  Korean = 'KOREAN',
  Danish = 'DANISH',
  Arabic = 'ARABIC',
  French = 'FRENCH',
  Polish = 'POLISH',
  Slovac = 'SLOVAK',
  English = 'ENGLISH',
  Russian = 'RUSSIAN',
  Deutsch = 'DEUTSCH',
  Chinese = 'CHINESE',
  Spanish = 'SPANISH',
  Italian = 'ITALIAN',
  Latvian = 'LATVIAN',
  Maltese = 'MALTESE',
  Finnish = 'FINNISH',
  Swedish = 'SWEDISH',
  Estonian = 'ESTONIAN',
  Japanese = 'JAPANESE',
  Romanian = 'ROMANIAN',
  Croatian = 'CROATIAN',
  Bulgarian = 'BULGARIAN',
  Hungarian = 'HUNGARIAN',
  Ukrainian = 'UKRAINIAN',
  Slovenian = 'SLOVENIAN',
  Indonesian = 'INDONESIAN',
  Lithuanian = 'LITHUANIAN',
  Portuguese = 'PORTUGUESE',
  Belarusian = 'BELARUSIAN',
}

export enum RequestPriorityEnum {
  HighPriority = 'HIGH_PRIORITY',
  MediumPriority = 'MEDIUM_PRIORITY',
  LowPriority = 'LOW_PRIORITY',
}

export enum RequestStatusEnum {
  Open = 'OPEN',
  Closed = 'CLOSED',
  OnApproval = 'ON_APPROVAL',
  Declined = 'DECLINED',
}

export enum RequestLifecycleStatusEnum {
  Deleted = 'DELETED',
  Actual = 'ACTUAL',
}

export enum RequestOverdueEnum {
  Overdue = 'OVERDUE',
  Valid = 'VALID',
}

export enum OptionEntityEnum {
  Domain = 'DOMAIN',
  Technology = 'TECHNOLOGY',
  Profession = 'PROFESSION',
  VisaType = 'VISA_TYPE',
  JobTitle = 'JOB_TITLE',
  VacancyStatus = 'VACANCY_STATUS',
  CandidateSource = 'CANDIDATE_SOURCE',
  CandidateSourceClarification = 'CANDIDATE_SOURCE_CLARIFICATION',
  Office = 'OFFICE',
  InternationalCertificates = 'INTERNATIONAL_CERTIFICATES',
}

export const SelectOptionEntityName = {
  [OptionEntityEnum.Domain]: 'domainOptions',
  [OptionEntityEnum.Technology]: 'technologyOptions',
  [OptionEntityEnum.Profession]: 'professionOptions',
  [OptionEntityEnum.VisaType]: 'visaTypesOptions',
  [OptionEntityEnum.VacancyStatus]: 'vacancyStatus',
  [OptionEntityEnum.CandidateSource]: 'candidateSourceOptions',
  [OptionEntityEnum.CandidateSourceClarification]: 'candidateSourceClarificationOptions',
  [OptionEntityEnum.Office]: 'officeOptions',
  [OptionEntityEnum.JobTitle]: 'jobTitleOptions',
  [OptionEntityEnum.InternationalCertificates]: 'certificateOptions',
};

export const GradeColors = {
  [GradeEnum.Trainee]: '#5D5D5D',
  [GradeEnum.Intern]: '#5D5D5D',
  [GradeEnum.JuniorMinus]: '#086862',
  [GradeEnum.Junior]: '#086862',
  [GradeEnum.JuniorPlus]: '#086862',
  [GradeEnum.MiddleMinus]: '#0B4174',
  [GradeEnum.Middle]: '#0B4174',
  [GradeEnum.MiddlePlus]: '#0B4174',
  [GradeEnum.SeniorMinus]: '#B14320',
  [GradeEnum.Senior]: '#B14320',
  [GradeEnum.SeniorPlus]: '#B14320',
  [GradeEnum.Lead]: '#9F2147',
  [GradeEnum.HEAD]: '#9F2147',
};

export enum RequestPreScreeningType {
  ResponseCreate = 'RESPONSE_CREATE',
  ResponseDelete = 'RESPONSE_DELETE',
  Approval = 'APPROVAL',
  Disapproval = 'DISAPPROVAL',
}

export const RequestPreScreeningText: { [key: string]: string } = {
  [RequestPreScreeningType.Approval]: 'pages.analytics.approved',
  [RequestPreScreeningType.Disapproval]: 'pages.analytics.disapproved',
  [RequestPreScreeningType.ResponseDelete]: 'pages.analytics.removedFromRequest',
  [RequestPreScreeningType.ResponseCreate]: 'pages.analytics.suggested',
};

export const PURPOSE_BY_EMPLOYMENT_FORM_MAP = {
  [PurposeEnum.Employment]: [
    EmploymentFormsEnum.Employee,
    EmploymentFormsEnum.Contractor,
    EmploymentFormsEnum.Entrepreneur,
  ],
  [PurposeEnum.Trainee]: [EmploymentFormsEnum.Internship],
  [PurposeEnum.Courses]: [EmploymentFormsEnum.Courses],
};

const PUBLISHABLE_PURPOSES: PurposeEnum[] = [PurposeEnum.Trainee, PurposeEnum.Courses];

export const isPublishablePurpose = (purpose?: PurposeEnum) => PUBLISHABLE_PURPOSES.includes(purpose);
